import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

// import {
//   ApolloProvider,
//   ApolloClient,
//   HttpLink,
//   InMemoryCache,
// } from "@apollo/client";

import { AuthenticationContextProvider } from "./context/authentication/authentication.context";
import { AnnouncementsContextProvider } from "./context/announcements/announcements.context";
import { TeamsContextProvider } from "./context/teams/teams.context";
import { DropdownDataContextProvider } from "./context/dropdown-data/dropdown-data.context";
import { SidebarProvider } from "./context/sidebar/sidebar.context";

import App from "./App";

import reportWebVitals from "./reportWebVitals";

import "./index.css";

ReactDOM.render(
  <React.StrictMode>
    <AuthenticationContextProvider>
      <DropdownDataContextProvider>
        <AnnouncementsContextProvider>
          <TeamsContextProvider>
            <SidebarProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </SidebarProvider>
          </TeamsContextProvider>
        </AnnouncementsContextProvider>
      </DropdownDataContextProvider>
    </AuthenticationContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
